export default class Debounce {
    private timeoutId: any;
    private pending: Function | null = null;

    public debounce(fn: Function, ms = 500) {
        this.pending = fn;
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(() => this.flush(), ms)
    }

    /**
     * Drops a call that is still waiting out its delay, without running it.
     */
    public cancel() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
        this.pending = null;
    }

    /**
     * Runs a call that is still waiting out its delay, immediately. Callers that must
     * not lose the last change - a store being serialized before the page goes away,
     * say - can use this to close the window where a pending call is simply dropped.
     * Safe to call when nothing is pending.
     */
    public flush() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
        const fn = this.pending;
        this.pending = null;
        if (fn) fn();
    }
}
